import { render } from "./MyKachelComponent.vue?vue&type=template&id=54f2cc1e&scoped=true"
import script from "./MyKachelComponent.vue?vue&type=script&lang=js"
export * from "./MyKachelComponent.vue?vue&type=script&lang=js"

import "./MyKachelComponent.vue?vue&type=style&index=0&id=54f2cc1e&scoped=true&lang=scss"

import exportComponent from "/Users/cc/www/doit2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2cc1e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
